var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 5.61497L14.3764 4.85377L12.5057 6.79187L10.6351 4.85377L9.90038 5.61497L11.771 7.55307L9.90038 9.49117L10.6351 10.2524L12.5057 8.31427L14.3764 10.2524L15.1111 9.49117L13.2405 7.55307L15.1111 5.61497ZM8.33716 15.1111C8.26822 15.1108 8.20002 15.0963 8.13652 15.0685C8.07301 15.0407 8.01546 15.0002 7.9672 14.9492L3.99663 10.7922H0.521073C0.382876 10.7922 0.250339 10.7354 0.152619 10.6341C0.0548986 10.5329 0 10.3956 0 10.2524V4.85377C0 4.71059 0.0548986 4.57327 0.152619 4.47203C0.250339 4.37079 0.382876 4.31391 0.521073 4.31391H3.99663L7.9672 0.156987C8.06483 0.0564379 8.1969 0 8.33456 0C8.47222 0 8.60429 0.0564379 8.70192 0.156987C8.80009 0.256662 8.85628 0.392491 8.85824 0.534889V14.5713C8.85824 14.7144 8.80334 14.8517 8.70562 14.953C8.6079 15.0542 8.47536 15.1111 8.33716 15.1111Z",
    fill: "#F6F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.61b903b1a370c279179be9389dd1fd3c.svg";
export { ForwardRef as ReactComponent };